import { useEffect, useState } from "react";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Loading } from "../../components/Loading";



import { ConfigType } from "../../contexts/AppConfigContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import "./index.css";
import { VendorOrderItem } from "../../components/vendorOrderItem/vendorOrderItem";
import Swal from "sweetalert2";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";
import { useSeller } from "../../hooks/useSeller";
import ReactLoading from "react-loading";
import InputMask from "react-input-mask";
import { useFilters } from "../../hooks/useFilters";
import { useOrder } from "../../hooks/useOrder";
import { ModalFiltroPedidoVendedor } from "../../components/ModalFiltroPedidoVendedor/ModalFiltroPedidoVendedor";

export type jsonCart = {
  name: string;
  price: number;
  unitPrice: number;
  discount: number;
  discountGeral: number;
  promotional_price: number;
  quantity: number;
};

type content = {
  productName: string;
  discount: number;
  discountGeral: number;
};

export type products = {
  price: number;
  content: content;
  discount: number;
};

type status = {
  id: number;
  name: string;
  slug: string;
};

type order = {
  orderidExt: string;
  integration: string;
  deliveryTax: string;
  discountGeneral: string;
  products: products[];
  status: status;
};

type customerAddress = {
  typeAddress: string;
  street: string;
  number: string;
  state: string;
  city: string;
  district: string;
  zipCode: string;
};

type customer = {
  name: string;
  doc: string;
  email: string;
  order: order;
  customerAddress: customerAddress;
};

export type vendorCart = {
  status: string;
  urlCart: string;
  created: string;
  guid: string;
  customerName: string;
  cpfCustomer: string;
  jsonCart: jsonCart[];
  canceled: string;
  Customer: customer;
};

type CartStatusOption = {
  select: string;
  value: string;
};



type OrdenationType = {
  name: string;
  type: string;
  order: string
}

export function SellerOrder() {
  const navigate = useNavigate();
  const { vendorCart, setVendorCart } = useFilters();
  const { getAppConfig } = useAppConfig();
  const { registerAccess } = usePluginspace();
  const { getTokenSellertoRequest } = useSeller();
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState<ConfigType | void>();
  const [page, setPage] = useState(1);
  const [request, setRequest] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [maskCpfjCnpj, setMaskCpfjCnpj] = useState("999.999.999-99");
  const [disableNumber, setDisableNumber] = useState(false);
  const [disableDoc, setDisableDoc] = useState(false);
  const [loadingHeader, setLoadingHeader] = useState(true);

  const [openModalFiltroPedido, setOpenModalFiltroPedido] = useState(false);

  const [orderType, setOrderType] = useState<OrdenationType>({ name: "Mais recente", type: "customerCart.created", order: "DESC" });

  const [isDropdownOpen, setDropdownOpen] = useState(false);


  const orderTypes: OrdenationType[] = [
    { name: "Mais recente", type: "customerCart.created", order: "DESC" },
    { name: "Mais antigo", type: "customerCart.created", order: "ASC" },
    { name: "Status", type: "customerCart.status", order: "DESC" },
    { name: "Nome do Cliente", type: "customerCart.customerName", order: "DESC" },
  ]


  async function handleMaisRecentesSearchOrders(value: OrdenationType) {
    setLoading(true);
    setOrderType(value);
    setDropdownOpen(false);
    await searchOrders(1, value);
    setLoading(false);
  }

  const [vendorCarts, setvendorCart] = useState<vendorCart[]>([]);

  async function getConfig() {
    //setLoading(true);
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
    await searchOrders();

    setLoading(false);
  }


  function checkBottom(event: any) {
    console.log(`ajashjkd`)
    const bottom =
      event.target.scrollHeight -
      event.target.scrollTop -
      event.target.clientHeight <=
      50;
    if (bottom && !request) {
      if (!hasNextPage) return;
      const newPage = page + 1;
      setPage(newPage);

      setRequest(true);

      searchMoreOrders(newPage, orderType);
    }
  }

  function changeMaskCpf(newDocument: string) {
    const onlyNumbers = newDocument.replace(/\D/g, "");

    if (onlyNumbers.length > 11) {
      setMaskCpfjCnpj("99.999.999/9999-99");
    } else {
      setMaskCpfjCnpj("999.999.999-99");
    }
  }



  async function searchOrders(page?: number, ordenation?: OrdenationType) {
    try {
      setLoading(true);

      setIsLoading(true);

      setPage(page ? page : 1);

      let newPage = page ? page : 1;

      const newOrdernatipon = ordenation ? ordenation : orderType

      await api
        .post(`/api/customerCart/vendor/filter?take=10&skip=${newPage - 1}&page=${newPage}&order=${newOrdernatipon.order}&field=${newOrdernatipon.type}`,
          vendorCart,
          {
            headers: {
              Authorization: `Bearer ${await getTokenSellertoRequest()}`,
            },
          }
        )
        .then((response: any) => {
          const data = response.data

          if (data) {
            setHasNextPage(data.meta.hasNextPage);
            setvendorCart(data.data);
          }
          setLoading(false);
          setIsLoading(false);
          setRequest(false);
        })
        .catch((err: any) => {
          setLoading(false);
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "Não foi possivel retornar os pedidos do Vendendor",
          });
          return null;
        });
      setLoading(false);


      setDisableDoc(false);
      setDisableNumber(false);
    } catch (error) {
      console.log(error);
    }
  }

  async function searchMoreOrders(page?: number, ordenation?: OrdenationType) {
    try {
      //setLoading(true);

      setIsLoading(true);

      setPage(page ? page : 1);

      let newPage = page ? page : 1;

      const newOrdernatipon = ordenation ? ordenation : orderType

      await api
        .post(`/api/customerCart/vendor/filter?take=10&skip=${newPage - 1}&page=${newPage}&order=${newOrdernatipon.order}&field=${newOrdernatipon.type}`,
          vendorCart,
          {
            headers: {
              Authorization: `Bearer ${await getTokenSellertoRequest()}`,
            },
          }
        )
        .then((response: any) => {
          const data = response.data

          if (data) {
            setHasNextPage(data.meta.hasNextPage);
            const newVendorCarts = [...vendorCarts, ...data.data];
            setvendorCart(newVendorCarts);
          }
          setLoading(false);
          setIsLoading(false);
          setRequest(false);
        })
        .catch((err: any) => {
          setLoading(false);
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "Não foi possivel retornar os pedidos do Vendendor",
          });
          return null;
        });
      setLoading(false);


      setDisableDoc(false);
      setDisableNumber(false);
    } catch (error) {
      console.log(error);
    }
  }





  useEffect(() => {
    registerAccess("vendor-order");
    getConfig();
  }, []);

  const [searchParams] = useSearchParams();
  const [lastRefresh, setLastRefresh] = useState(searchParams.get("refresh"));


  async function handleSearchOrders() {
    setLoading(true);
    await searchOrders();
    setLoading(false);
  }


  useEffect(() => {
    const interval = setInterval(() => {
      const newRefresh = searchParams.get("refresh");
      if (newRefresh && (newRefresh !== lastRefresh)) {
        //loadFilter()
        setLastRefresh(newRefresh);
        handleSearchOrders()
      }
    }, 100);

    return () => clearInterval(interval);
  }, [searchParams, lastRefresh]);

  return (
    <div className="search-order">
      <div
        className="content-search-order"

      >
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="meu_novo_componente">
            <div className="title-search">
              <h2>Resumo dos Carrinhos</h2>
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => navigate(-1)}
                style={{ cursor: "pointer" }}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.978551 2.21657L6.957 8.2395L0.978551 14.2624L2.97137 16.2701L8.94981 10.2471L14.9283 16.2701L16.9211 14.2624L10.9426 8.2395L16.9211 2.21657L14.9283 0.208931L8.94981 6.23186L2.97137 0.208931L0.978551 2.21657Z"
                  fill="#636363"
                />
              </svg>
            </div>
            <div className="search-body-new" onScroll={checkBottom}>
              <div className="search-inputs-vendor-new" >
                <input
                  style={disableNumber ? { backgroundColor: "#D5D5D5" } : {}}
                  type="text"
                  placeholder="Buscar por número do pedido"
                  disabled={disableNumber}
                  value={vendorCart.order || ""}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") searchOrders();
                  }}
                  onChange={(event) => {
                    setVendorCart({
                      ...vendorCart,
                      order: event.target.value,
                      cpfCustomer: "",
                    });
                    if (event.target.value !== "") {
                      setDisableDoc(true);
                    } else {
                      setDisableDoc(false);
                    }
                  }}
                />

                <InputMask
                  style={disableDoc ? { backgroundColor: "#D5D5D5" } : {}}
                  mask={maskCpfjCnpj}
                  type="text"
                  value={vendorCart.cpfCustomer || ""}
                  disabled={disableDoc}
                  placeholder={
                    config?.content.pdv && config?.content.pdv.allowSellCnpj
                      ? "Número do CPF ou CNPJ"
                      : "Número do CPF"
                  }
                  onKeyDown={(event) => {
                    if (event.key === "Enter") searchOrders();
                  }}
                  onInput={(event) =>
                    changeMaskCpf((event.target as HTMLInputElement).value)
                  }
                  onChange={(event) => {
                    setVendorCart({
                      ...vendorCart,
                      cpfCustomer: event.target.value,
                      order: "",
                    });
                    if (event.target.value !== "") {
                      setDisableNumber(true);
                    } else {
                      setDisableNumber(false);
                    }
                  }}
                />
              </div>

              <div className="button-search-vendor">
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Pesquisar"
                  onClick={() => searchOrders()}
                />
              </div>
              <div className="filter-options-div">
                <button className="button-filter" onClick={() => setOpenModalFiltroPedido(true)}>
                  <p>Filtrar</p>
                </button>

                <div className="select-options"
                  onBlur={(e) => {
                    // Só dispara onBlur se o foco sair da div e não for para um elemento filho
                    if (!e.currentTarget.contains(e.relatedTarget as Node)) {
                      setDropdownOpen(false);
                    }
                  }}>
                  <div
                    className="selected-option"
                    style={{
                      borderRadius: isDropdownOpen ? "10px 10px 0 0 " : "10px",
                      borderBottom: isDropdownOpen ? "none" : "",
                    }}
                    onClick={() => setDropdownOpen(!isDropdownOpen)}
                    tabIndex={0}

                  >
                    <p>{orderType.name}</p>
                  </div>
                  {isDropdownOpen && (
                    <div className="optionsDropdown">
                      {orderTypes.map((option: OrdenationType) => (
                        <div
                          key={option.name}
                          className="optionDropdown"
                          onClick={() => handleMaisRecentesSearchOrders(option)}
                          tabIndex={-1}
                        >
                          <p>{option.name}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div id="orders" className="orders-finded-new">
                {vendorCarts.length > 0 &&
                  vendorCarts.map((order) => (
                    <VendorOrderItem
                      order={order}
                      key={order.guid}
                      colorStatus={config?.webappcolor.backgroundstatus}
                      colorActiveStatus={
                        config?.webappcolor.backgroundstatusactive
                      }
                      fontStatus={config?.webappcolor.fontstatus}
                    />
                  ))}

                {vendorCarts.length === 0 && (
                  <div className="no-product">
                    <h2>Nenhum pedido encontrado com os filtros aplicados</h2>
                  </div>
                )}
              </div>
            </div>
            {isLoading && (
              <>
                <ReactLoading
                  type="bubbles"
                  color="#96969680"
                  width={64}
                  height={64}
                />

              </>
            )

            }


          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="order"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>

      <ModalFiltroPedidoVendedor setOpenModalFiltroOrder={setOpenModalFiltroPedido} openModalFiltroOrder={openModalFiltroPedido} config={config} />
    </div>
  );
}
